<template>
  <ContentBox class="confirm-dialog">
    <template
      v-if="titleText || titleIcon || hasHeaderSlot"
      #header
    >
      <slot
        name="title"
        :titleText="titleText"
        :titleIcon="titleIcon"
        :titleIconStyles="titleIconStyles"
        :confirmClick="confirmClick"
        :confirmButtonText="confirmButtonText"
        :confirmButtonIcon="confirmButtonIcon"
        :confirmButtonTheme="confirmButtonTheme"
        :cancelClick="cancelClick"
        :cancelButtonText="cancelButtonText"
        :cancelButtonIcon="cancelButtonIcon"
        :cancelButtonTheme="cancelButtonTheme"
      >
        <span
          v-if="titleIcon"
          class="icon"
        >
          <SvgIcon
            :data="titleIcon"
            :style="titleIconStyles"
          />
        </span>
        <span>{{ titleText }}</span>
      </slot>
    </template>
    <template #default>
      <slot
        :messageText="messageText"
        :messageIcon="messageIcon"
        :messageIconStyles="messageIconStyles"
        :confirmClick="confirmClick"
        :confirmButtonText="confirmButtonText"
        :confirmButtonIcon="confirmButtonIcon"
        :confirmButtonTheme="confirmButtonTheme"
        :cancelClick="cancelClick"
        :cancelButtonText="cancelButtonText"
        :cancelButtonIcon="cancelButtonIcon"
        :cancelButtonTheme="cancelButtonTheme"
      >
        <span
          v-if="messageIcon"
          class="icon"
        >
          <SvgIcon
            :data="messageIcon"
            :style="messageIconStyles"
          />
        </span>
        <span>{{ messageText }}</span>
      </slot>
    </template>
    <template #footer>
      <slot
        name="footer"
        :confirmClick="confirmClick"
        :confirmButtonText="confirmButtonText"
        :confirmButtonIcon="confirmButtonIcon"
        :confirmButtonTheme="confirmButtonTheme"
        :cancelClick="cancelClick"
        :cancelButtonText="cancelButtonText"
        :cancelButtonIcon="cancelButtonIcon"
        :cancelButtonTheme="cancelButtonTheme"
      >
        <div class="selection-container">
          <NorticButton
            :theme-type="confirmButtonTheme"
            :icon="confirmButtonIcon"
            @click="confirmClick"
          >
            {{ confirmButtonText }}
          </NorticButton>
          <NorticButton
            :theme-type="cancelButtonTheme"
            :icon="cancelButtonIcon"
            @click="cancelClick"
          >
            {{ cancelButtonText }}
          </NorticButton>
        </div>
      </slot>
    </template>
  </ContentBox>
</template>

<script>
import ContentBox from '@/components/common/layout/content-box/ContentBox.vue';
import NorticButton from '@/components/common/button/nortic-button/NorticButton.vue';

export default {
  name: 'ConfirmDialog',
  components: { NorticButton, ContentBox },
  props: {
    messageText: {
      type: String,
      default: 'N/A',
    },
    messageIcon: {
      type: Object,
      default: null,
    },
    messageIconStyles: {
      type: [Object, String],
      default: '',
    },
    titleText: {
      type: String,
      default: null,
    },
    titleIcon: {
      type: Object,
      default: null,
    },
    titleIconStyles: {
      type: [Object, String],
      default: '',
    },
    confirmButtonText: {
      type: String,
      default: 'Ja',
    },
    confirmButtonIcon: {
      type: Object,
      default: null,
    },
    confirmButtonTheme: {
      type: String,
      default: 'accent',
    },
    cancelButtonText: {
      type: String,
      default: 'Avbryt',
    },
    cancelButtonIcon: {
      type: Object,
      default: null,
    },
    cancelButtonTheme: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.title;
    },
  },
  methods: {
    confirmClick() {
      this.$emit('confirm', 'Confirmed!');
    },
    cancelClick() {
      this.$emit('cancel', 'Cancelled!');
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirm-dialog {
    min-width: 250px;
    max-width: 50%;
    box-sizing: border-box;

    .icon {
      margin-right: 0.5em;
    }

    .selection-container {
      display: grid;
      grid-template-columns: 1fr 1fr;

      button {
        &:first-child {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }

        &:last-child {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }

        width: auto;
        justify-content: center;
      }
    }
  }
</style>
